<script>
import {
  authComputed,
  reportComputed,
  reportListMethod,
  commomMethod,
} from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'

export default {
  components: {},
  props: {
    actiontype: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    downloadtype: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      isDownloading: false,
      fields: {},
    }
  },
  computed: {
    ...authComputed,
    ...reportComputed,
  },
  methods: {
    ...reportListMethod,
    ...commomMethod,

    // Fetch report from api
    fetchReportData() {
      this.isDownloading = true
      const filter = {
        page: 1,
        limit: 10000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchReportDetails({ filter, route: this.type }).then((data) => {
        this.prepareReportData(data.docs)
      })
    },

    // Prepare Data According to report type
    prepareReportData(data) {
      var finalData = []
      data.forEach((element) => {
        var item = {}
        if (this.type === 'event') {
          item['Event Name'] = element.name
          item['Total View'] = element.totalview
          item['Total Subscribed'] = element.totalsubscribes
          item['Total Unsubscribed'] = element.totalunsubscribes
        } else if (this.type === 'course') {
          item['Course Name'] = element.name
          item['Total View'] = element.totalview
          item['Total In Progress'] = element.totaluserinprogress
          item['Total Completed'] = element.totalusercompleted
          item['Avg. Rating'] = element.avg_rating
        } else if (this.type === 'feedback') {
          item['Date'] = element.createdAt
          item['Email'] = element.email
          item['feedback'] = element.feedback
          item['Rating'] = element.rating
          item['Course Name'] = element.course
        } else if (this.type === 'survey') {
          item['Date'] = element.createdAt
          item['Avg. Rating'] = element.avg_rating
          item['Question / Answer'] = JSON.stringify(element.question)
        } else if (this.type === 'user') {
          item['Name'] = element.name
          item['Course In Progress'] = element.courseinprogress
          item['Course Completed'] = element.coursecompleted
          item['Subscribed Event'] = element.coursecompleted
          item['Login Count'] = element.logincount
        }
        finalData.push(item)
      })

      this.JSONToCSVConvertor(finalData, this.type, true)
    },

    // JSON to CSV Converter
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData

      var CSV = ''
      // Set Report title in first row or line

      // CSV += ReportTitle + '\r\n\n';

      // This condition will generate the Label/Header
      if (ShowLabel) {
        var row = ''

        // This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {
          // Now convert each value to string and comma-seprated
          row += index + ','
        }

        row = row.slice(0, -1)

        // append Label row with line break
        CSV += row + '\r\n'
      }

      // 1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        // eslint-disable-next-line no-redeclare
        var row = ''

        // 2nd loop will extract each column and convert it in string comma-seprated
        // eslint-disable-next-line no-redeclare
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",'
        }

        row.slice(0, row.length - 1)

        // add a line break after each row
        CSV += row + '\r\n'
      }

      if (CSV === '') {
        alert('Invalid data')
        return
      }

      // Generate a file name
      var fileName = `Report ${ReportTitle}`
      // this will remove the blank-spaces from the title and replace it with an underscore
      // fileName += ReportTitle.replace(/ /g,"_");

      // Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV)

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension

      // this trick will generate a temp <a /> tag
      var link = document.createElement('a')
      link.href = uri

      // set the visibility hidden so it will not effect on your web-layout
      link.style = 'visibility:hidden'
      link.download = fileName + '.csv'

      // this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.isDownloading = false
    },

    // Download from AWS S3
    downloadContent() {
      this.isDownloading = true
      this.fetchSignedURL(this.item.document)
        .then((data) => {
          this.isDownloading = false
          const url = data
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.item.document)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          this.isDownloading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <b-button
    v-if="type !== 'custom' && type !== 'requested'"
    variant="info"
    size="sm"
    @click="fetchReportData"
  >
    <b-spinner v-if="isDownloading" small></b-spinner>
    <i v-if="!isDownloading" class="ti-download"></i>
  </b-button>
  <b-button v-else variant="info" size="sm" @click="downloadContent">
    <b-spinner v-if="isDownloading" small></b-spinner>
    <i v-if="!isDownloading" class="ti-download"></i>
  </b-button>
</template>
